import { render, staticRenderFns } from "./mutil-text.vue?vue&type=template&id=3eae044e&scoped=true&"
import script from "./mutil-text.vue?vue&type=script&lang=ts&"
export * from "./mutil-text.vue?vue&type=script&lang=ts&"
import style0 from "./mutil-text.vue?vue&type=style&index=0&id=3eae044e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eae044e",
  null
  
)

export default component.exports